import { defaultDateConfig } from '@vista-digital/i18n';
import { nonEmptyStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccDateConfig = {
    formats: defaultDateConfig.formats,
    ordinalStringFormatter: defaultDateConfig.ordinalStringFormatter,
    startWeekOnSunday: false
};
export const occDateConfigValidator = Validator.object({
    formats: Validator.object({
        iso: nonEmptyStringValidator,
        dateLong: nonEmptyStringValidator,
        dateShort: nonEmptyStringValidator,
        dateDefault: nonEmptyStringValidator,
        timeLong: nonEmptyStringValidator,
        timeShort: nonEmptyStringValidator,
        timeDefault: nonEmptyStringValidator
    }),
    ordinalStringFormatter: Validator.fn(),
    startWeekOnSunday: Validator.boolean()
});
//# sourceMappingURL=date.js.map